import {saveData, getData, clearData, findByID} from "../db/db_helper"

//load from DB
export const getOnlineOffers = async () =>{
    return await getData("offers") || []
}

export const getOffllineOffers = async () =>{
    return await getData("sync_offers") || []
}

export const getAllOffers = async () =>{
    const online = await getOnlineOffers()
    const offline = await getOffllineOffers()
    const all = [...online, ...offline]
    return all
}

export const getOffersByCategorie = async(id) =>{
    const all = await getAllOffers()
    return all.filter(p => p.category.id === id )
}

export const getOfferById = async(id)=>{
    const online = await findByID("offers", id)
    const offline = await findByID("sync_offers", id)
    return online || offline || null
}

export const getOfferIndex = (id, offers)=>{
    return offers.findIndex(o => o.id === id);
}

export const getOfferByCode = async(code) =>{
    const offers = await getAllOffers()
    const target = offers.find(o => o.offerCode === code && o.status === "ACTIVE")
    return target
}

export const saveOffers = async (obj) =>{
    saveData("offers", obj)
}

export const clearSyncOffers = async () =>{
    clearData("sync_offers")
}

// Helper

export const disableOffer = async(id) =>{
    try {
            const target = await getOfferById(id)
            target.status = "INACTIVE"
            const localData = await getOffllineOffers()
    
            let index = -1
            const serverData = await getOnlineOffers()
            index = await getOfferIndex(id, serverData)
            console.log("Index in server data", index)
            if(index !== -1){
                serverData.splice(index, 1)
                await saveData("offers", serverData)
                localData.push(target)
                await saveData("sync_offers", localData)
                return true
            } 
    
            index = await getOfferIndex(id, localData)
            console.log("Index in local data", index)
            if(index !== -1){
                localData[index] = target
                await saveData("sync_offers", localData)
                return true
            } 
            return false;
    
        } catch (error) {
            console.error("Fehler bei offline Offer Update:", error);
            return null;
        }
}